import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '../../types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (recurringImportId: number) => {
  if (!recurringImportId) {
    throw new Error('Recurring import ID is required');
  }
};

type RequestParams = {
  recurringImportId: number;
};

type Response = {
  header: string[];
};

export const getImportSourceHeaders = async (
  scope: RequestScope,
  { recurringImportId }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(recurringImportId);

    const response = await scopedApi(scope).get<EndpointResponse<Response>>(`/recurring_import_header/${recurringImportId}`, requestOptions);

    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
